import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../api/supabase';

export default function MobileProFormas() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    let query = supabase.from('quotations')
      .select('id, quotation_number, status, total_amount, currency:currency_id(code), created_at, clients(full_name)')
      .neq('status', 'VOID')
      .order('created_at', { ascending: false })
      .limit(40);
    if (q) {
      const { data: mc } = await supabase.from('clients').select('id').ilike('full_name', `%${q}%`).limit(20);
      const ids = (mc || []).map(c => c.id);
      const orParts = [`quotation_number.ilike.%${q}%`, ...(ids.length ? [`client_id.in.(${ids.join(',')})`] : [])].join(',');
      query = query.or(orParts);
    }
    const { data } = await query;
    setRows(data || []);
    setLoading(false);
  }, [q]);

  useEffect(() => { load(); }, [load]);

  return (
    <div style={{ padding: '20px 16px', paddingBottom: 80 }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: '#1a1a2e', marginBottom: 16 }}>Pro Formas</div>
      <input
        className="form-input"
        placeholder="Search pro forma or client…"
        value={q}
        onChange={e => setQ(e.target.value)}
        style={{ marginBottom: 16, fontSize: 15 }}
      />
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Loading…</div>
      ) : (
        <div style={{ background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
          {rows.length === 0 && <div style={{ padding: '24px 16px', color: '#aaa', fontSize: 13, textAlign: 'center' }}>No pro formas found</div>}
          {rows.map((q2, i) => (
            <div key={q2.id} onClick={() => navigate(`/quotations/${q2.id}`)}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', borderBottom: i < rows.length - 1 ? '1px solid #f3f3f3' : 'none', cursor: 'pointer' }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#f07040' }}>{q2.quotation_number}</div>
                <div style={{ fontSize: 13, color: '#555', marginTop: 3 }}>{q2.clients?.full_name}</div>
                <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>{q2.created_at?.slice(0, 10)}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                {q2.status === 'CONVERTED' && <div style={{ fontSize: 11, fontWeight: 700, color: '#16a34a', marginBottom: 4 }}>CONVERTED</div>}
                <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a2e' }}>
                  {q2.currency?.code} {parseFloat(q2.total_amount || 0).toLocaleString()}
                </div>
                <div style={{ fontSize: 11, color: '#bbb', marginTop: 2 }}>View →</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
